import React from 'react'

function AboutCompany() {
  return (
    <div>AboutCompany</div>
  )
}

export default AboutCompany